const APP_CONTROL_HEIGHT = "var(--app-control-height, 37px)";
const APP_CONTROL_INNER_HEIGHT = "calc(var(--app-control-height, 37px) - 2px)";

export const groupColourStyles = {
  group: (styles) => ({
    paddingBottom: "4px",
  }),
  groupHeading: (styles) => ({
    fontFamily: "Montserrat, sans-serif",
    fontSize: "0.75rem",
    textTransform: "uppercase",
    color: "#7f8590",
    padding: "0.5rem 0.85rem 0.5rem 1.05rem",
    letterSpacing: "1px",
  }),
  option: (styles, state) => ({
    ...styles,
    padding: "0.45rem 0.85rem 0.45rem 1.75rem",
    backgroundColor: state.isSelected
      ? "#dff0ff"
      : state.isFocused
        ? "#eaf5ff"
        : "#ffffff",
    color: "#233754",
    "&:hover": {
      backgroundColor: state.isSelected ? "#dff0ff" : "#eaf5ff",
    },
  }),
  menu: (provided, state) => ({
    ...provided,
    zIndex: "99999",
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 100060,
  }),
  control: (styles, state) => ({
    ...styles,
    minHeight: APP_CONTROL_HEIGHT,
    borderRadius: "7px",
    border: "1px solid #cfd9eb",
    boxShadow: "0 0 0!important",
    backgroundColor: "#ffffff",
    borderColor: state.isFocused ? "#8aa9e8" : "#cfd9eb",
    "&:hover": {
      borderColor: state.isFocused ? "#8aa9e8" : "#b8c9ea",
      backgroundColor: "#fefeff",
    },
    "&:focus": {
      borderColor: state.isFocused ? "#8aa9e8" : "#cfd9eb",
    },
    boxShadow: state.isFocused
      ? "0 0 0 0.18rem rgba(79, 120, 223, 0.2)"
      : "none",
  }),
  menuList: (styles) => ({
    ...styles,
    maxHeight: "260px",
    textTransform: "capitalize",
  }),
  valueContainer: (styles) => ({
    ...styles,
    paddingLeft: "0.75rem",
    paddingRight: "0.75rem",
    minHeight: APP_CONTROL_INNER_HEIGHT,
  }),
  placeholder: (styles) => ({
    ...styles,
    whiteSpace: "nowrap",
    fontFamily: "Open Sans, sans-serif",
    fontSize: "0.875rem",
  }),
  input: (styles) => ({
    ...styles,
    caretColor: "transparent",
  }),
  singleValue: (styles) => ({
    ...styles,
    color: "#35415a",
    fontSize: "0.875rem",
  }),
  indicatorSeparator: (styles) => ({
    ...styles,
    display: "none",
  }),
  dropdownIndicator: (styles, state) => ({
    ...styles,
    color: state.isFocused ? "#6f89b7" : "#7e90b1",
    "&:hover": {
      color: "#6f89b7",
    },
  }),
  clearIndicator: (styles) => ({
    ...styles,
    color: "#9aa7be",
    "&:hover": {
      color: "#7f90ad",
    },
  }),
  indicatorsContainer: (styles) => ({
    ...styles,
    height: APP_CONTROL_INNER_HEIGHT,
    "> div": {
      padding: "0",
      "&:last-child": {
        paddingRight: "8px",
      },
    },
  }),
  multiValueLabel: (styles) => ({
    ...styles,
    color: "red",
  }),
  multiValue: (styles) => ({
    ...styles,
    backgroundColor: "#f2f2f2",
    border: "0.063rem solid #dce4ec",
    color: "#b5b5b5",
    margin: "-5px 14px 0 -9px",
    "&:first-of-type": {
      color: "#b5b5b5",
    },
    "&:last-child": {
      backgroundColor: "transparent",
      svg: {
        fill: "#b5b5b5",
      },
    },
  }),
};

export const nonGroupColourStyles = {
  group: (styles) => ({
    paddingBottom: "4px",
  }),
  groupHeading: (styles) => ({
    fontFamily: "Montserrat, sans-serif",
    fontSize: "0.75rem",
    textTransform: "uppercase",
    color: "#4a4a4aff",
    padding: "0.5rem 0.85rem 0.5rem 1.05rem",
    letterSpacing: "1px",
  }),
  option: (styles, state) => ({
    ...styles,
    padding: "0.45rem 1rem",
    backgroundColor: state.isSelected
      ? "#dff0ff"
      : state.isFocused
        ? "#eaf5ff"
        : "#ffffff",
    color: "#233754",
    "&:hover": {
      backgroundColor: state.isSelected ? "#dff0ff" : "#eaf5ff",
    },
  }),
  menu: (provided, state) => ({
    ...provided,
    zIndex: "99999",
    textTransform: "capitalize",
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 100060,
    textTransform: "capitalize",
  }),
  container: (styles) => ({
    ...styles,
    flex: "1 1 auto",
    userSelect: "none",
  }),
  control: (styles, state) => ({
    ...styles,
    minHeight: APP_CONTROL_HEIGHT,
    borderRadius: "7px",
    border: "1px solid #cfd9eb",
    boxShadow: "0 0 0!important",
    fontWeight: "400",
    fontSize: "1rem",
    fontFamily: "'Public Sans', sans-serif",
    userSelect: "none",
    backgroundColor: "#ffffff",
    borderColor: state.isFocused ? "#8aa9e8" : "#cfd9eb",
    "&:hover": {
      borderColor: state.isFocused ? "#8aa9e8 !important" : "#b8c9ea",
      backgroundColor: "#fefeff",
    },
    "&:focus": {
      borderColor: state.isFocused ? "#8aa9e8" : "#cfd9eb",
    },
    boxShadow: state.isFocused
      ? "0 0 0 0.18rem rgba(79, 120, 223, 0.2)"
      : "none",
  }),
  menuList: (styles) => ({
    ...styles,
    maxHeight: "260px",
    userSelect: "none",
    zIndex: "99999",
  }),
  valueContainer: (styles) => ({
    ...styles,
    paddingLeft: "0.75rem",
    paddingRight: "0.75rem",
    minHeight: APP_CONTROL_INNER_HEIGHT,
    userSelect: "none",
    pointerEvents: "auto",
    "i.ri-delete-bin-6-line": {
      display: "none",
    },
  }),
  placeholder: (styles) => ({
    ...styles,
    whiteSpace: "nowrap",
    color: "#8b98b1",
    fontSize: "0.875rem",
    fontWeight: "400",
    userSelect: "none",
  }),
  input: (styles) => ({
    ...styles,
    caretColor: "transparent",
  }),
  singleValue: (styles) => ({
    ...styles,
    color: "#35415a",
    fontSize: "0.875rem",
    fontWeight: "500",
    userSelect: "none",
    pointerEvents: "auto",
  }),
  indicatorSeparator: (styles) => ({
    ...styles,
    display: "none",
    userSelect: "none",
  }),
  dropdownIndicator: (styles, state) => ({
    ...styles,
    color: state.isFocused ? "#6f89b7" : "#7e90b1",
    userSelect: "none",
    "&:hover": {
      color: "#6f89b7",
    },
  }),
  clearIndicator: (styles) => ({
    ...styles,
    color: "#9aa7be",
    userSelect: "none",
    "&:hover": {
      color: "#7f90ad",
    },
  }),
  indicatorsContainer: (styles) => ({
    ...styles,
    height: APP_CONTROL_INNER_HEIGHT,
    userSelect: "none",
    "> div": {
      padding: "0",
      userSelect: "none",
      "&:last-child": {
        paddingRight: "8px",
        userSelect: "none",
      },
    },
  }),
  multiValue: (styles) => ({
    ...styles,
    backgroundColor: "rgb(242 242 242)",
    border: "rgb(190 190 190)",
    color: "rgb(143 140 203)",
    margin: "-5px 14px 0 -9px",
    "&:first-of-type": {
      color: "#46c5fe",
    },
    "&:last-child": {
      backgroundColor: "transparent",
      svg: {
        fill: "#46c5fe",
      },
    },
  }),
  multiValueRemove: (styles) => ({
    color: "#000",
  }),
  multiValueLabel: (styles) => ({
    color: "#000",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRadius: "2px",
    fontSize: "85%",
    padding: "3px",
    paddingLeft: "6px",
    boxSizing: "border-box",
  }),
};

export const nonGroupColourStylesPreview = {
  group: (styles) => ({
    paddingBottom: "4px",
  }),
  groupHeading: (styles) => ({
    fontFamily: "Montserrat, sans-serif",
    fontSize: "0.75rem",
    textTransform: "uppercase",
    color: "#7f8590",
    padding: "0.5rem 0.85rem 0.5rem 1.05rem",
    letterSpacing: "1px",
  }),
  option: (styles, state) => ({
    ...styles,
    padding: "0.25rem 1rem",
    backgroundColor: state.isSelected
      ? "#dff0ff"
      : state.isFocused
        ? "#eaf5ff"
        : "#ffffff",
    color: "#233754",
    "&:hover": {
      backgroundColor: state.isSelected ? "#dff0ff" : "#eaf5ff",
    },
  }),
  menu: (provided, state) => ({
    ...provided,
    zIndex: "99999",
  }),
  control: (styles, state) => ({
    ...styles,
    minHeight: "calc(1.6em + 0.75rem + 2px)",
    borderRadius: "0",

    backgroundColor: "transparent",
    border: "none",
    borderBottom: "0.063rem solid transparent",
    boxShadow: "none",
    fontSize: "1rem",
    "&:hover": {
      borderBottom: "0.063rem solid #e3e3e3",

      indicatorsContainer: (styles) => ({
        ...styles,
        opacity: "1",
      }),
    },
    borderColor: state.isFocused ? "#5b5b5b" : "#eee",
    "&:hover": {
      borderColor: state.isFocused ? "#5b5b5b" : "#eee",
    },
    "&:focus": {
      borderColor: state.isFocused ? "#5b5b5b" : "#eee",
    },
    boxShadow: state.isFocused ? "0 0 0 1px 6E5DC6" : "none",
  }),

  menuList: (styles) => ({
    ...styles,
    maxHeight: "150px",
  }),
  valueContainer: (styles) => ({
    ...styles,
    paddingLeft: "0",
    paddingRight: "0.85rem",
    height: "34px",
    borderBottom: "0.063rem solid transparent",
    "&:focus": {
      borderBottom: "0.063rem solid #5b5b5b",
    },
  }),
  placeholder: (styles) => ({
    ...styles,
    whiteSpace: "nowrap",
    fontFamily: "Open Sans, sans-serif",
    fontSize: "0.875rem",
  }),
  singleValue: (styles) => ({
    ...styles,
    color: "defaultColor",
    fontSize: "0.875rem",
  }),
  indicatorSeparator: (styles) => ({
    ...styles,
    display: "none",
  }),
  dropdownIndicator: (styles, state) => ({
    ...styles,
    color: state.isFocused ? "#6f89b7" : "#7e90b1",
    "&:hover": {
      color: "#6f89b7",
    },
  }),
  clearIndicator: (styles) => ({
    ...styles,
    color: "#9aa7be",
    "&:hover": {
      color: "#7f90ad",
    },
  }),
  indicatorsContainer: (styles) => ({
    ...styles,
    height: "34px",
    opacity: "0",
    "> div": {
      padding: "0",
      "&:last-child": {
        paddingRight: "8px",
      },
    },
  }),
  multiValue: (styles) => ({
    ...styles,
    backgroundColor: "#f2f2f2",
    border: "0.063rem solid #dce4ec",
    color: "#b5b5b5",
    // margin: "-5px 14px 0 -9px",
    margin: "0px",
    "&:first-of-type": {
      color: "#b5b5b5",
    },
    "&:last-child": {
      backgroundColor: "transparent",
      svg: {
        fill: "#b5b5b5",
      },
    },
  }),
  input: (styles) => ({
    ...styles,
    userSelect: "none",
  }),
};

export const autoHeightMultiValue = {
  valueContainer: (styles) => ({
    ...styles,
    paddingLeft: "0.75rem",
    paddingRight: "0.75rem",
    minHeight: APP_CONTROL_INNER_HEIGHT,
    paddingTop: "0",
  }),
  multiValue: (styles) => ({
    ...styles,
    backgroundColor: "#f2f2f2",
    border: "0.063rem solid #dce4ec",
    color: "#b5b5b5",
    margin: "2px",
    "&:first-of-type": {
      color: "#b5b5b5",
    },
    "&:last-child": {
      backgroundColor: "transparent",
      svg: {
        fill: "#b5b5b5",
      },
    },
  }),
  input: (styles) => ({
    ...styles,
    minHeight: "21px",
    padding: 0,
    margin: 0,
  }),
  option: (styles, state) => ({
    ...styles,
    padding: "0.25rem 1rem",
    backgroundColor: state.isSelected
      ? "#dff0ff"
      : state.isFocused
        ? "#eaf5ff"
        : "#ffffff",
    color: "#233754",
    "&:hover": {
      backgroundColor: state.isSelected ? "#dff0ff" : "#eaf5ff",
    },
  }),
  control: (styles, state) => ({
    ...styles,
    minHeight: APP_CONTROL_HEIGHT,
    borderRadius: "7px",
    border: "1px solid #cfd9eb",
    boxShadow: "0 0 0!important",
    fontWeight: "400",
    fontSize: "1rem",
    fontFamily: "'Public Sans', sans-serif",
    userSelect: "none",
    backgroundColor: "#ffffff",
    borderColor: state.isFocused ? "#8aa9e8" : "#cfd9eb",
    "&:hover": {
      borderColor: state.isFocused ? "#8aa9e8" : "#b8c9ea",
      backgroundColor: "#fefeff",
    },
    "&:focus": {
      borderColor: state.isFocused ? "#8aa9e8" : "#cfd9eb",
    },
    boxShadow: state.isFocused
      ? "0 0 0 0.18rem rgba(79, 120, 223, 0.2)"
      : "none",
  }),
  dropdownIndicator: (styles, state) => ({
    ...styles,
    color: state.isFocused ? "#6f89b7" : "#7e90b1",
    "&:hover": {
      color: "#6f89b7",
    },
  }),
  clearIndicator: (styles) => ({
    ...styles,
    color: "#9aa7be",
    "&:hover": {
      color: "#7f90ad",
    },
  }),
};

export const formControlView = {
  control: (styles, state) => ({
    ...styles,
    borderWidth: " 0.094rem !important",
    backgroundColor: "transparent !important",
    borderTop: "none !important",
    borderLeft: "none !important",
    borderRight: "none !important",
    borderBottomColor: "transparent !important",
    boxShadow: "none !important",
    fontSize: "1rem",
    borderRadius: "0",
    borderColor: state.isFocused ? "#5b5b5b" : "#eee",
    "&:hover": {
      borderColor: state.isFocused ? "#5b5b5b" : "#eee",
    },
    "&:focus": {
      borderColor: state.isFocused ? "#5b5b5b" : "#eee",
    },
    boxShadow: state.isFocused ? "0 0 0 1px 6E5DC6" : "none",
  }),

  indicatorsContainer: (styles) => ({
    ...styles,
    opacity: "0",
  }),

  valueContainer: (styles) => ({
    ...styles,
    padding: "0!important",
  }),
};

export const bpFieldStyles = {
  control: (styles, state) => ({
    ...styles,
    height: APP_CONTROL_HEIGHT,
    borderColor: "#eee",
    borderColor: state.isFocused ? "#5b5b5b" : "#eee",
    "&:hover": {
      borderColor: state.isFocused ? "#5b5b5b" : "#eee",
    },
    "&:focus": {
      borderColor: state.isFocused ? "#5b5b5b" : "#eee",
    },
    boxShadow: state.isFocused ? "0 0 0 1px 6E5DC6" : "none",
  }),
};

export const overTheNextElement = {
  control: (styles, state) => ({
    ...styles,
    height: APP_CONTROL_HEIGHT,
    borderColor: "#eee",
    borderColor: state.isFocused ? "#5b5b5b" : "#eee",
    "&:hover": {
      borderColor: state.isFocused ? "#5b5b5b" : "#eee",
    },
    "&:focus": {
      borderColor: state.isFocused ? "#5b5b5b" : "#eee",
    },
    boxShadow: state.isFocused ? "0 0 0 1px 6E5DC6" : "none",
  }),
  menu: (provided, state) => ({
    ...provided,
    position: "relative",
    zIndex: "99999",
  }),
  menuList: (styles) => ({
    ...styles,
    maxHeight: "150px",
    position: "relative",
    zIndex: "999999",
  }),
  indicatorSeparator: (styles) => ({
    ...styles,
    display: "none",
  }),
  
};

export const smallElement = {
  group: (styles) => ({
    paddingBottom: "4px",
  }),
  groupHeading: (styles) => ({
    fontFamily: "Montserrat, sans-serif",
    fontSize: "0.75rem",
    textTransform: "uppercase",
    color: "#7f8590",
    padding: "0.5rem",
    letterSpacing: "1px",
  }),
  option: (styles, state) => ({
    ...styles,
    padding: "0.25rem",
    backgroundColor: state.isSelected
      ? "#dff0ff"
      : state.isFocused
        ? "#eaf5ff"
        : "#ffffff",
    color: "#233754",
    "&:hover": {
      backgroundColor: state.isSelected ? "#dff0ff" : "#eaf5ff",
    },
  }),
  menu: (provided, state) => ({
    ...provided,
    zIndex: "99999",
  }),
  container: (styles) => ({
    ...styles,
    flex: "1 1 auto",
    userSelect: "none",
    height: "25px",
  }),
  control: (styles, state) => ({
    ...styles,
    // minHeight: "calc(1.6em + 0.75rem + 2px)",
    borderRadius: "7px",
    border: "0.063rem solid #c7cdd4",
    boxShadow: "0 0 0!important",
    fontWeight: "400",

    fontFamily: "'Public Sans', sans-serif",
    userSelect: "none",
    minHeight: "25px",
    borderColor: state.isFocused ? "#5b5b5b" : "#eee",
    "&:hover": {
      borderColor: state.isFocused ? "#5b5b5b" : "#eee",
    },
    "&:focus": {
      borderColor: state.isFocused ? "#5b5b5b" : "#eee",
    },
    boxShadow: state.isFocused ? "0 0 0 1px 6E5DC6" : "none",
  }),
  menuList: (styles) => ({
    ...styles,
    maxHeight: "150px",
    userSelect: "none",
  }),
  valueContainer: (styles) => ({
    ...styles,
    paddingLeft: "0.85rem",
    paddingRight: "0.85rem",
    height: "25px",
    userSelect: "none",
  }),
  placeholder: (styles) => ({
    ...styles,
    whiteSpace: "nowrap",
    userSelect: "none",
  }),
  singleValue: (styles) => ({
    ...styles,
    color: "defaultColor",
    userSelect: "none",
    height: "25px",
  }),
  indicatorSeparator: (styles) => ({
    ...styles,
    display: "none",
    userSelect: "none",
  }),
  dropdownIndicator: (styles, state) => ({
    ...styles,
    color: state.isFocused ? "#6f89b7" : "#7e90b1",
    userSelect: "none",
    "&:hover": {
      color: "#6f89b7",
    },
  }),
  clearIndicator: (styles) => ({
    ...styles,
    color: "#9aa7be",
    userSelect: "none",
    "&:hover": {
      color: "#7f90ad",
    },
  }),
  indicatorsContainer: (styles) => ({
    ...styles,
    height: "25px",
    userSelect: "none",
    "> div": {
      padding: "0",
      userSelect: "none",
      "&:last-child": {
        paddingRight: "8px",
        userSelect: "none",
      },
    },
  }),
  multiValue: (styles) => ({
    ...styles,
    backgroundColor: "#f2f2f2",
    border: "0.063rem solid #dce4ec",
    color: "#b5b5b5",
    margin: "-5px 14px 0 -9px",
    "&:first-of-type": {
      color: "#b5b5b5",
    },
    "&:last-child": {
      backgroundColor: "transparent",
      svg: {
        fill: "#b5b5b5",
      },
    },
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 999999,
  }),
};

export const cardStyles = {
  card: {
    position: "relative",
    display: "flex", // Set to flex to properly use flex properties
    flexDirection: "column",
    height: "200px",
    width: "150px",
    border: "1px solid #cfd9eb",
    margin: "10px",
  },
  image: {
    width: "100%",
    height: "100%", // Make the image take the full height of the card
    objectFit: "contain",
  },
  cardContent: {
    flex: "1", // Make the card content (image) take remaining space
    overflow: "hidden",
    position: "relative", // Position relative for absolute positioning of overlay
  },
  overlay: {
    position: "absolute",
    top: "0",
    right: "0", // Position the overlay in the top right corner
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(173, 216, 255, 0.6)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    alignItems: "flex-end",
    padding: "10px",
    boxSizing: "border-box",
    opacity: 0,
    transition: "opacity 0.3s ease-in-out",
  },
  eyeIcon: {
    color: "#1c7de1", // Blue color for the eye icon
    fontSize: "24px",
    cursor: "pointer",
    backgroundColor: "#fff", // White background for the eye icon
    padding: "0.2rem 0.7rem 0", // Add padding to the eye icon
    borderRadius: "5px", // Make the background circular
    position: "absolute", // Position the eye icon within the overlay
    top: "10px", // Adjust the top and right values as needed for positioning
    right: "10px",
  },
  cardFooter: {
    // position: 'relative', // Position relative to allow z-index on overlay
    padding: "10px",
    // backgroundColor: '#f1f1f1',
    textAlign: "center",
    // zIndex: '1', // Ensure cardFooter is above overlay
  },
  title: {
    margin: "0",
    color: "#000", // Black color for the title text
    backgroundColor: "#fff", // White background for the title area
  },
  activeCard: {
    border: "2px solid #5b5b5b", // Blue border for the active card
  },
};

export const rightBorderRadiusNone = {
  control: (styles, state) => ({
    ...styles,
    minHeight: "calc(1.698em + 0.75rem + 2px)",
    borderRadius: "7px",
    border: "0.063rem solid #c7cdd4",
    boxShadow: "0 0 0!important",
    fontWeight: "400",
    fontSize: "0.875rem",
    fontFamily: "'Public Sans', sans-serif",
    userSelect: "none",
    borderColor: state.isFocused ? "#5b5b5b" : "#eee",
    "&:hover": {
      borderColor: state.isFocused ? "#5b5b5b !important" : "#eee",
    },
    "&:focus": {
      borderColor: state.isFocused ? "#5b5b5b" : "#eee",
    },
    boxShadow: state.isFocused ? "0 0 0 1px 6E5DC6" : "none",

    borderRadius: ".35rem 0 0 .35rem",
  }),
};
